import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const ITALIC_PLUGIN_ID = 'italic' as const;
export type ItalicPluginID = typeof ITALIC_PLUGIN_ID;

export type ItalicPluginElement = EditorElement;

export type ItalicPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
  }
>;

export type ItalicPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    ItalicPluginOptions & {
      pluginID: ItalicPluginID;
      hotkey: string;
      component: ComponentType<any>;
      pluginName: string;
      icon: ComponentType<any>;
    }
>;
